import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { ParseDate } from "../../../../../Helpers/DateHelper";
import { useTranslation } from "react-i18next";
import AssignedAssessmentApplicationRow from "./AssignedAssessmentApplicationRow";

const AssignedAssessmentsListRow = ({ ticket }) => {
  const { t } = useTranslation();

  return (
    <Card className="default-card py-3 px-2 px-xxl-4 mb-3">
      <Row className="justify-content-between" style={{ borderBottom: "2px solid #e7ecef", padding: "0 12px" }}>
        <Col xs={12} sm="auto" className="text-20 text-color-gray-dark fw-medium">
          {ticket.assessmentName}
        </Col>
        <Col xs={12} sm={true} className="text-16 text-color-gray-dark fw-medium align-content-center">
          <Row className="justify-content-sm-end">
            <Col xs="auto" className="ps-0 pe-2">
              {t("assignedAssessmentCreatedByLabel")}: {ticket.createdBy}
            </Col>
            <Col xs="auto" className="px-0">
              {t("assignedAssessmentDateLabel")}: {ParseDate(ticket.createdAt).date} {ParseDate(ticket.createdAt).time}
            </Col>
          </Row>
        </Col>
        <Col xs="auto" className="text-20 text-color-gray-dark fw-medium">
          {/* Buttons like wrapUp/pdf can go here if needed */}
        </Col>
      </Row>

      <Row className="mx-0">
        <Col>
          {ticket.applications.map((application, i) => {
            const applicationResult = ticket.results.find(
              (appResult) =>
                appResult.applicationId === application.applicationId &&
                appResult.applicationType === application.applicationType
            );
            const isPastDeadline = new Date() > new Date(new Date(ticket.createdAt).getTime() + 5 * 24 * 60 * 60 * 1000);

            const lastItem = i === ticket.applications.length - 1;
            const appIdString = `#${application.applicationType}A${application.applicationId}T${ticket.ticketId}R${applicationResult?.resultId || ""}`;

            return (
              <AssignedAssessmentApplicationRow
                key={i}
                application={application}
                applicationResult={applicationResult}
                appIdString={appIdString}
                lastItem={lastItem}
                isPastDeadline={isPastDeadline}
              />
            );
          })}
        </Col>
      </Row>
    </Card>
  );
};

export default AssignedAssessmentsListRow;
